import { DeleteOutlined, EditFilled, PlusOutlined } from '@ant-design/icons';
import { Button, Modal, Switch, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
    fetchStateRecords,
    insertStateRecord,
    updateStateRecord,
    deleteStateRecord,
    changeStateParameter,
} from '../../../redux/slice/state.slice';
import moment from 'moment';
import DebouncedSearch from '../../Common/DebouncedSearch';
import CommonTable from '../../Common/AdvancedTable';

const inputClass = `form-control
block
w-full
px-3
py-1.5
text-base
font-normal
text-gray-700
bg-white bg-clip-padding
border border-solid border-gray-300
rounded
transition
ease-in-out
m-0
focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`;

export default function StateMaster() {
    const State = useSelector((state) => state.state);
    const dispatch = useDispatch();

    const [pagination, setPagination] = React.useState({
        pageNo: 0,
        limit: 15,
        count: 0,
        sortBy: 1,
        sortField: '_id',
        keywords: '',
    });

    useEffect(() => {
        setPagination({
            pageNo: State.pageNo || 0,
            limit: State.limit || 15,
            count: State.count || 0,
            sortBy: State.sortBy || 1,
            sortField: State.sortField || '_id',
            keywords: State.keywords || '',
        });
        fetchRecord({
            pageNo: State.pageNo || 0,
            limit: State.limit || 15,
            sortBy: State.sortBy || 1,
            sortField: State.sortField || '_id',
            keywords: State.keywords || '',
        });
    }, []);

    useEffect(() => {
        setPagination((prev) => ({
            ...prev,
            count: State.count || 0,
        }));
    }, [State.count]);

    function fetchRecord({ pageNo, limit, sortBy, sortField, keywords }) {
        dispatch(fetchStateRecords({ pageNo, limit, sortBy, sortField, keywords }));
    }

    const handleDeleteSlide = (id) => {
        dispatch(deleteStateRecord({ id }));
        setTimeout(() => {
            fetchRecord(pagination);
        }, 100);
    };

    const handleSearch = (keywords) => {
        const updatedPagination = { ...pagination, pageNo: 0, keywords };
        setPagination(updatedPagination);
        dispatch(changeStateParameter(updatedPagination));
        dispatch(fetchStateRecords(updatedPagination));
    };

    const handleStateSubmit = async (data, id, setOpen) => {
        try {
            if (id) {
                data._id = id;
                await dispatch(updateStateRecord(data));
            } else {
                await dispatch(insertStateRecord(data));
            }

            setTimeout(() => {
                dispatch(fetchStateRecords(pagination));
            }, 100);
            setOpen(() => false);
        } catch (err) {
            alert(err.message);
        }
    };

    const handleStatusChange = async (checked, id) => {
        try {
            // var _slides = State.records.map(s => {
            //     if(s._id == id) {
            //         s.status = checked;
            //     }
            //     return s;
            // })
            // setSlides(_slides);
        } catch (err) {
            alert(err.message);
        }
    };

    const onChangeTable = (paginate, filter, sorter, extra) => {
        const updatedSortField = sorter.field || '_id';
        const updatedSortBy = sorter.order === 'ascend' ? 1 : -1;

        const updatedPagination = {
            ...pagination,
            pageNo: paginate.current - 1,
            limit: paginate.pageSize,
            sortBy: updatedSortBy,
            sortField: updatedSortField,
            keywords: pagination.keywords,
        };

        setPagination(updatedPagination);
        dispatch(changeStateParameter(updatedPagination));
        dispatch(fetchStateRecords(updatedPagination));
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            sorter: (a, b) => a.name?.localeCompare(b.name),
        },
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            width: 120,
            sorter: (a, b) => a.code?.localeCompare(b.code),
        },
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 180,
            render: (e, record) => moment(e).format('lll'),
            sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: 'Action',
            width: 150,
            fixed: 'right',
            render: (e, record) => (
                <div className="flex gap-2" key={record._id}>
                    <ManagerModel
                        key={record._id}
                        id={record._id}
                        submitHandler={handleStateSubmit}
                        _state={record}
                    />
                    <Button
                        title="Delete"
                        icon={<DeleteOutlined />}
                        onClick={() => handleDeleteSlide(record._id)}
                    ></Button>
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className="flex items-center justify-between mb-4">
                <h1 className="text-xl">States</h1>
                <div className="flex gap-2 ml-auto">
                    <DebouncedSearch
                        onSearch={handleSearch}
                        placeholder="Search States..."
                    />
                    <ManagerModel submitHandler={handleStateSubmit} />
                </div>
            </div>
            <CommonTable
                data={State.records}
                columns={columns}
                loading={State.loading}
                pagination={pagination}
                onChange={onChangeTable}
            />
        </div>
    );
}

function ManagerModel({ id, _state, submitHandler }) {
    const [open, setOpen] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
    } = useForm();

    const onSubmit = (body) => {
        submitHandler(body, id, setOpen);
    };

    return (
        <div className="">
            <Button
                className={!id ? 'float-right mb-2' : ''}
                title={id ? 'Edit' : 'Add'}
                icon={id ? <EditFilled /> : <PlusOutlined />}
                onClick={() => setOpen(true)}
            >
                {id ? '' : 'Add'}
            </Button>

            <Modal
                centered
                title={(id ? 'Edit' : 'Add') + ' State'}
                open={open}
                onOk={() => setOpen(false)}
                footer={false}
                onCancel={() => setOpen(false)}
            >
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {/* <div className="form-group mb-6">
                            <label className="font-bold">Country Name <span className='text-red-600'>*</span></label>
                              <span className='text-red-600 md:ml-4'>{errors?.country_name?.message}</span>
                            <input type="text" className={inputClass} name="country_name" {...register("country_name", { required: 'field is required' })}
                                aria-describedby="country_name" placeholder="country_name" defaultValue={_state?.country_name || ''} />
                        </div> */}
                        <div className="form-group mb-6">
                            <label className="font-bold">
                                Name <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 md:ml-4">
                                {errors?.name?.message}
                            </span>
                            <input
                                type="text"
                                className={inputClass}
                                name="name"
                                {...register('name', { required: 'field is required' })}
                                aria-describedby="name"
                                placeholder="name"
                                defaultValue={_state?.name || ''}
                            />
                        </div>
                        <div className="form-group mb-6">
                            <label className="font-bold">
                                Code <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 md:ml-4">
                                {errors?.code?.message}
                            </span>
                            <input
                                type="text"
                                className={inputClass}
                                name="code"
                                {...register('code', { required: 'field is required' })}
                                aria-describedby="code"
                                placeholder="code"
                                defaultValue={_state?.code || ''}
                            />
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="px-4 py-2 rounded shadow hover:bg-gray-200"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
}
